import { render, staticRenderFns } from "./TransparentSidebar.vue?vue&type=template&id=1a5ac179&scoped=true&"
import script from "./TransparentSidebar.vue?vue&type=script&lang=js&"
export * from "./TransparentSidebar.vue?vue&type=script&lang=js&"
import style0 from "./TransparentSidebar.vue?vue&type=style&index=0&id=1a5ac179&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a5ac179",
  null
  
)

export default component.exports